export const PDF_STYLES = {
    headerFontSize: 12,
    headerSubtitleFontSize: 8,
    footerFontSize: 8,
    defaultFontSize: 8,
    headerBg: '#D3D3D3',
    groupBg: '#BEDFE6',
    negativeColorArgb: 'FFEF0000',
    negativeHex: '#f70505',
    headerTextColor: '#000000',
    leftMargin: 4,
    rightMargin: 4,
    firstPageHeaderHeight: 40,
    otherPageHeaderHeight: 20,
    headerRowPaddingY: 4, // top/bottom cell padding for the grid's column-caption row — bigger than the default 1pt used elsewhere so the header row reads taller
    detailRowDividerColor: '#CCCCCC', // bottom border on plain 'data' rows — deliberately visible, unlike the default '#ffffff' cell border used everywhere else
    detailRowDividerWidth: 0.5, // pt
    detailRowDividerDash: [0.01, 1.5], // near-zero dash + round line cap (set where drawn) renders as dots, not dashes
    headerGroupFontSizeBoost: 1, // added on top of defaultFontSize for the grid header row and group/summary rows, so they read larger than plain data rows
};